module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("By the time the primary response team arrived, the priest had no vital signs. They worked quickly, trying to restore a heartbeat with the drugs their protocols called for, but the priest failed to respond. After thirty minutes, the physician monitoring their work via radio link told them to call the code—signifying they were to stop their efforts. The district medical investigator, also a physician, would be sent to certify the death. Father Anselm’s body now lay shrouded with a blanket awaiting the arrival of county authorities.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sister Agatha stood near the altar, her throat constricted with grief, her face wet with tears. She believed in the afterlife with every fiber of her being, but to see death come so quickly, up close, like this…Father Anselm had been like a breath of fresh air at the monastery. His irreverent humor had always been tempered by his deep and abiding devotion to God. He’d served the Church with his whole heart, and brightened his ministry with a touch of laughter. She couldn’t think of a more fitting homage for the young priest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hearing heavy footsteps at the back of the chapel, she looked up and saw the sheriff approach. She’d thought she’d never be able to feel anything through the mind-numbing grief that engulfed her, but she’d been wrong. Seeing him up close for the first time in years sent a jolt of emotion through her. Tom Green’s dark brown hair had turned gray around the temples, and his face had acquired some hard lines, but the kid she’d known in school was still there—the ten-year-old boy who’d driven Sister Charitas crazy by making a list of the creatures Noah should have left off the Ark, such as flies, centipedes, and schoolteachers. Then the college senior who’d filled their apartment with balloons and roses on her birthday—only to find out he’d gotten the date wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He strode up to her, a scowl on his face. “Are you in charge here now?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She nearly choked. “No, not hardly.” Her gaze fell on the men from the office of the medical examiner as they crouched by Father Anselm’s body.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who’s the head nun? Mother Superior?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Reverend Mother Margaret Mary is our abbess,” she answered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I need to interview her right now, and everyone else who was present at Mass.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The parishioners who attended Mass have already gone home. Father Anselm’s abrupt death frightened them and they left as soon as possible. I didn’t try to stop them because they were witnesses to a tragedy, not a crime.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Get Reverend Mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She took a deep breath and tried to get her temper in check. “This is a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("monastery")]), _vm._v(", Sheriff, and we are a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cloistered")]), _vm._v(" order. Most of the nuns here don’t have contact with the outside world. You can’t just barge in here, order Reverend Mother about, and disrupt everything—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The priest’s death is responsible for the disruption, not me. I’m here to help put things back to normal. Now either bring the abbess here or take me to see her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As a nun, Sister Agatha should have been used to following orders, but it had always been one of her shortcomings. Right now she was feeling protective. This monastery was her home, the nuns her family. Reverend Mother, in particular, carried the weight of all temporal and spiritual matters that concerned the monastery. She didn’t need any additional burdens. She would do everything in her power to protect their abbess.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You can’t enter the enclosure,” she said firmly. “You’ll have to go to the outer parlor, and she’ll come to the grille. You can speak to her there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Like a jail, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shot him a hard look, and he shrugged. As she started to leave the chapel, she saw Sister Mary Lazarus and Sister Bernarda come out of the hallway that led to the cloister, bucket and scrubbing brushes in hand. They were obviously intending to clean up the chapel—their usual task after Mass.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Stop right there, Sisters,” Sheriff Green’s voice cracked through the air like a whip. “No one touches anything until I say so. Is that clear?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Tom,” Sister Agatha reached out and touched his arm lightly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He glanced back at her and moved his arm away. “You’re Sister Agatha now, and I’m Sheriff Green. Don’t try to use our former friendship to manipulate me. I’m here on official business, and I have a job to do. Now go tell your superior I’ll need to speak to her in ten minutes. Then come back here. I have to get your statement, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All right. But get this through your thick head. If you intend to get any cooperation from this monastery, you’ll treat Reverend Mother with the respect she deserves.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("After Sister Agatha and the other extern nun, Sister Bernarda, described the events and their observations and actions leading up to the arrival of the primary response team, Sheriff Green went to speak to Reverend Mother.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The outer parlor was divided from the enclosure by a grid of vertical and horizontal metal rods that physically separated the two areas, though visibility was only slightly impaired. Sheriff Green stood before the grille and stared at the bars with distaste. “Mother Abbess, I’m here as a law enforcement official. I’d rather speak to you face-to-face.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" face-to-face,” Reverend Mother answered softly, “and we can see each other well enough. You may ask me any questions you have, but our rules of enclosure dictate that it has to be done this way. I hope you’ll understand.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All right. If that’s the way it has to be.” Green took a breath and regarded her pensively. “The priest, Father Anselm, probably died from a heart attack, at least based on the information I’ve received so far. But until the medical investigator confirms that, I’ve got procedures to follow and I need to get some background information. Did you speak to the father today before Mass?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. Sister Bernarda and Sister Agatha met him earlier this morning, when he came to deliver some donated supplies for our St. Francis’ Pantry. Our novice and postulant probably helped put food away too, and may have spoken to him. But you’ll have to get the details from Sister Agatha. As sacristan, she may also have seen him when he came to celebrate Mass for us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He glanced at Sister Agatha coldly. She was seated nearby as her duties as portress demanded. “You could have saved me some time and told me this before.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You didn’t ask,” she answered simply.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Reverend Mother spoke. “You may find it helpful to remember that, as a general rule, our cloistered sisters do not leave the enclosure except in grave emergencies. Father was allowed inside, of course. He made himself available to us for confession and counseling whenever we needed him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Were there any confession or counseling sessions today?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No,” Reverend Mother responded. “And no one but Sister Agatha or Sister Bernarda could have spoken to him when he came to say Mass. The others were seated with me, within the enclosure, before he arrived.” She glanced at Sister Agatha, then back at the sheriff. “Please don’t hesitate to ask Sister Bernarda or Sister Agatha any further questions you may have. They’ll be glad to help you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can even reconstruct some of what Father did immediately prior to his heart attack, if you’d like. He spoke to me about his day,” Sister Agatha said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“When I need your help, I’ll let you know,” Sheriff Green said abruptly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His rudeness took her aback, but she didn’t say anything. Out of the corner of her eye, she noted Reverend Mother’s disapproving expression. Had she still been Mary Naughton, Sister Agatha would have cheerfully told him he had the manners of a pig, and showed him the door. As it was, however, she knew she should find a more charitable response. Perhaps she’d pray that Tom Green found a personality donor soon.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“For now, I’m going back to the scene. I’m expecting the district medical investigator, Jim Brown, to arrive shortly. I’ll know more once I talk to him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then what you need is medical confirmation that Father had a heart attack?” Reverend Mother asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If that’s what it was. If his death wasn’t from natural causes, that’ll pose a whole new set of problems, and I’ll need a list of everyone who was here today.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sister Bernarda can supply that for you. She was portress and would have been outside the chapel doors greeting those who came to Mass today,” Sister Agatha said. “She’s probably in the chapel now, standing by in case she’s needed as your people do their work.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That was the most diplomatic way of putting it, Sister Agatha mused. Their chapel was open to the public, so the main reason Sister Bernarda would remain there until they were gone was to make sure no one broached their enclosure.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How long will it take you to get the answers you need?” Reverend Mother asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t know yet. I’ll have to let you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Muttering a quick thank-you, Sheriff Green strode to the door, apparently heading back to the chapel to meet with his men. Sister Agatha glanced back at Reverend Mother and saw she was standing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Come see me in my office.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sister Agatha nodded, and locked the parlor doors since no other portress was available now, and hurried to Mother’s office. Taking a deep breath and bracing herself, Sister Agatha opened the door to Reverend Mother’s office. “Praised be Jesus Christ,” she said, as was customary.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Now and forever,” came Reverend Mother’s reply.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The sparsely finished room had an austere feel. There were two straight-backed wooden chairs before an oak desk that one of the businesses in town had donated to the monastery. A tall storage cabinet stood against one wall and a statue of the Blessed Virgin had been placed on a stand in the far corner. The only adornment on the white stucco walls was a large wooden cross.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sit down, child.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Reverend Mother called everyone child as was their monastic custom. Even elderly Sister Clothilde, who was reputedly in her eighties—no one knew for sure—was “child” to Mother, who was in her late fifties.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I couldn’t help but notice the sheriff’s attitude toward you. He came across as a man with little regard for our monastery. If that’s due to some history between you, I need to know. Father Anselm’s passing was a tragedy, but I have no intention of letting the police turn this monastery upside down. Our Lady of Hope is dedicated to prayer and I won’t allow anything to interfere with our duty to God.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sheriff Green and I knew each other a lifetime ago, Mother. We’ve been friends since we were kids and our relationship grew even closer after high school. We lived together our last two years in college. But after graduation, we both knew it was time to call it quits. Our outlooks on just about everything were totally different. We had a huge fight one day and Tom packed up and left.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So your relationship ended after college?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not quite. We never lived together again, but during the years my brother was sick, Tom would visit us often. I think he always hoped that we’d get back together someday. But our lives had already gone in two separate directions. When I told him I was entering the monastery, he was furious with me. He accused me of everything from being crazy to leading him on.” She paused, then shook her head. “That was twelve years ago, but he still seems to bear a grudge.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He probably thinks we took you away from him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But that’s not the way it was. The truth of it is that by the time Kevin died, my entire life had changed. During Kevin’s illness, I learned to rely on God. He was there and He filled my heart in a way nothing ever had before. Joining the order was the only step that made sense to me after that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did the sheriff know all that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I explained it to him, Mother, but he was too angry to listen. Yet none of this should matter now. He’s married. I saw the ring on his hand.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you think Sister Bernarda should be the one to deal with him until this is over?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I doubt that’ll make any difference. Sheriff Green apparently sees me as part of the monastery and the monastery as a part of me,” she said. “And, in that respect, he’s right.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Reverend Mother leaned back in her chair. “I want this matter settled, and the police gone. We can’t use our chapel for prayer or to chant the liturgy of the hours with those men in there. We’ve already missed Sext. That has never happened before.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll do my best to see that they’re out of here as soon as possible, Mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Come to me immediately if you encounter any problems.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, Mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("As Sister Agatha left Reverend Mother’s office and walked down the corridor, she could hear men’s voices coming from chapel. The sound was jarring.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The devil had brought chaos into the midst of them, but she intended to fight him. Taking a deep breath, she strode out into the chapel, and saw Sheriff Green going into the sacristy where Father Anselm had vested.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“One moment please,” she snapped, using her college professor tone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He turned his head, but continued walking.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t care what you think about me personally, Sheriff, but there are "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("rules")]), _vm._v(" in this monastery. Half of that sacristy is considered cloister, and you may not enter that half. You also need to be escorted into any area outside the chapel. Unless you and your men respect that, I’m prepared to file a complaint and go all the way to the governor’s office if I have to. And he’s Catholic.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The smile he gave her was cold. “Rules didn’t used to worry you so much. But not everything about you has changed. I see you’ve still got that temper. And you know what? It still doesn’t impress me.” He entered the priest’s side of the sacristy and began to study the two-way drawers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She explained the system to him without waiting to be asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll need to collect and examine the clothing the priest wore when he came in, and whatever else he left in here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d been a reporter long enough to have that request send a warning signal to her brain. “What’s going on? Did you discover something new concerning Father’s death?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I spoke to the medical investigator. The symptoms apparently don’t match a heart attack—at least not exactly. The MI’s preliminary ruling is death by an unknown cause—but I think he suspects foul play. The body is being transported to Albuquerque for an autopsy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tom Green turned and walked out of the sacristy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sister Agatha felt as if his words had suddenly sucked all the oxygen from the room. Murder, here, under their roof? She remembered following police cases as a reporter, then later with her journalism students. If there was one thing she remembered it was that an investigation of this nature left no one untouched. The delicate, orderly ebb and flow of their life at the monastery would be under siege now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She saw Sister Bernarda in the doorway. “We’re in trouble, aren’t we, Sister?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sister Bernarda’s military bark was strangely absent now, and she could understand why. The death of their chaplain had left all of them in shock. But neither of them could indulge their feelings now. She and Sister Bernarda were the monastery’s first line of defense.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’re about to face an invading army, Sister, and I see no way to stop it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I overheard someone say murder…is that true? Was Father murdered?” Sister Bernarda’s tone grew stronger, but she was still pale.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They don’t know yet, but apparently there’s enough evidence to make the law suspect something other than an accident or natural causes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sister Agatha saw Sheriff Green walking in their direction with a man in civilian clothes and a blue jacket. He had an ID badge clipped to his pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sister Agatha, Sister Bernarda, this is Jim Brown, the medical investigator. He has a few questions for Sister Bernarda.” Not giving either woman a chance to reply, the sheriff motioned to Brown, who led Sister Bernarda away to a nearby pew.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Questioning people separately was standard procedure, she knew that from her journalism days, but having these protocols enforced here filled her with dread for what lay ahead. To the police, they were all suspects now—no matter how far-fetched that seemed to her. She and Sister Bernarda were accustomed to interacting with the world outside the monastery. That was part of their duties. But the cloistered sisters would find contact with the police dismaying, to say the least.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay, Sister Agatha, let’s get back on track over here. Who else besides you saw Father this morning?” Green brought out a pen and small black notebook.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He spoke to Sister Bernarda, who was portress at the time. She rang the bell notifying us that he was here. Then there was our postulant, Celia, and our novice, Sister Mary Lazarus.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No one else? You’re sure? Think about it a moment before you answer.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s not impossible that he might have seen someone else, because he was already out of the pickup by the time we came to greet him. But as far as I know, it was just us. The cloistered sisters don’t come out to the front of our grounds.” She met his gaze. “I think you already know that none of us here would have harmed Father. Do you have to treat us like criminals?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not treating anyone like a criminal yet. If I were, the lot of you would be trooping down to the station house. I’m treating everyone like a witness to a suspicious death, possibly murder.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re showing very little respect for the nuns here, and not an ounce for me. Do you really hate me so much?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t hate you. Not at all. I’m married, and have my own life. And you’ve got yours—such as it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your sweet disposition is well hidden today, then.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m doing my job.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So am I. What other information do you need?” she added coldly. “I have other responsibilities.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Look, Mary…Sister Agatha. I’m not the enemy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then stop acting like one.” Seeing two deputies taking the altar cloth and placing it in a large paper bag, Sister Agatha immediately shifted her attention to them. “What do you think "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you’re")]), _vm._v(" doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They looked at her, then at the sheriff, who stood behind her, then resumed sealing and labeling the sack.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Evidence has to be examined and interpreted. I’m trying to cut you some slack, so chill out,” Sheriff Green said, shifting until he stood between her and the deputies. “You’re going to need to use the chapel, right? Nuns have church "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("all")]), _vm._v(" the time. The moment this place is cleaned up, any evidence that’s here will be compromised. I don’t want to risk that until I know for sure how and why Father Anselm died. If you’d rather, I can tape off the chapel for the next few days to preserve what may be a crime scene, and bar anyone from coming in at all. All things considered, I figured you’d prefer to have us take what we may need as evidence and free the scene for ordinary use as soon as possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All right. Remove what you need to examine, but I really don’t think you’re going to find anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’ll just have to wait and see. Now think back again. Did the father eat or drink anything while he was here, either right before Mass or earlier today? Did he get an injection or take a pill in the infirmary, or anything like that at all?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All I know is that he drank a glass of iced tea this morning when we were working in the food pantry—the monastery’s special blend.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay. Now, what about the sacramental wine and the communion wafer?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He was about to consecrate them when he became ill. So the answer is no, he never got to that part of the Mass.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All right. If you haven’t washed the tea glass he used, I’d like to take that into evidence. If there’s still a little bit of tea in it, so much the better. I’ll also need a sample of the tea from the source you used.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Normally that glass would have been washed and dried right away, but today we were so rushed, Celia probably didn’t have time. I’ll go see.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll come with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s fine.” She suddenly stopped and looked him in the eye. “You think he was poisoned, don’t you? But that’s nonsense.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re a nun. I’m a cop. I won’t tell you how to pray, and you don’t tell me how to conduct my investigation.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She considered arguing with him but, from what she remembered about Tom, she knew it would be futile. At that precise moment, one of the deputies knocked over a cruet of sacramental wine. Red liquid spilled onto the brick floor. She started to move toward the utility room next to the sacristy so she could get a towel to wipe up the spill, but he held her arm.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The deputy will clean it up.” He glowered at the deputy. “No more accidents. That’s inexcusable.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, sir,” the young deputy said, and looked around a few seconds before hurrying out of the chapel.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sister Agatha stared at the ever-widening pool of crimson wine. It flowed down the cracks between the bricks, staining everything in its path. Like the blood of the lamb that had been spilled for sinners, it ran freely, leaving its mark on everything it touched.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sadness settled over her spirit. She stepped back as the trail of unconsecrated wine reached the tip of the alpargates she wore—the flat, hemp-soled shoes that were part of the habit. Father’s life, like that crimson liquid, was just another promise left unfulfilled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who mixed the herbs for the tea Father Anselm drank?” Sheriff Green asked, interrupting her thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I did—it’s just a few herbs from Sister Clothilde’s garden. I keep a jar of it in St. Francis’ Pantry to offer the people who bring donations.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The deputy rushed back into the chapel with a handful of folded paper towels like those found in the chapel’s public rest room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let’s go see,” the sheriff said, ignoring the deputy and gesturing to the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she led Tom Green toward the pantry, one of the monastery bells began to ring. The deep, resonant sound came from the largest bell.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She stopped in her tracks to offer a prayer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s going on?” he grumbled when she looked up again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That bell was announcing Father’s death,” she explained, then continued walking. Reverend Mother would be meeting with the other nuns now. There were nine of them here in their small monastery. Prayers for Father Anselm’s soul would be said, and tonight would be a time of mourning. She knew that even Sister Ignatius, who’d never really approved of Father Anselm’s youthful levity, would be heartbroken. Death had claimed a member of their family.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("They found the glass, still unwashed, on the counter in the pantry. Sheriff Green bagged and labeled it as evidence, after putting on latex gloves. The trace of liquid at the bottom was poured into a labeled plastic medicine-type bottle and sealed. He also took a sample of the dry herbal tea mixture and sealed it in a labeled paper bag.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When they returned to the chapel a short time later, Jim Brown was putting his equipment away, and Father’s body, now inside a black zippered bag, was being wheeled out on a gurney.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sister, I’d like to talk to you,” Brown said, coming over to meet her as the sheriff placed the evidence he’d collected into a cardboard box.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“At your service,” she answered, hoping this wouldn’t take long. Sister Mary Lazarus was on her knees near the altar with scrub brush and bucket, starting, at last, to clean things up. Sister Bernarda was probably acting as portress right now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let’s sit down on one of the benches,” Jim suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She did as he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I have a few simple questions that I need you to answer, since you were trying to help the priest when he died.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Go ahead.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What exactly did he say? Did he complain of any pain?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sister Agatha related all she could recall, though the details were heartbreaking and her voice shook at times despite her efforts to remain calm. “He suffered—this I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You said that he was having auditory hallucinations. Is that correct?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, I never said that. Father told me he heard bells, but I took that at face value. For all I knew, it could have meant that his ears were ringing, or maybe it was God’s way of telling him not to be afraid. When people are about to pass on, they sometimes see and hear things that others don’t. I never concluded that he was hallucinating.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You also mentioned the paralysis of his facial muscles.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“His expression became rigid, yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Medical Investigator Brown stared at the floor. Minutes ticked by and Sister Agatha wondered if he’d forgotten she was there.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is that all, or do you still need me?” Sister Agatha asked softly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man looked up suddenly, as if he’d just remembered where he was. “I heard you tell the sheriff that Father had consumed some herbal tea earlier today. What kind of herbs are in that tea, Sister?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Some mint, some chamomile—all ordinary things that grow in our garden. Sister Clothilde has a special section for culinary herbs. The sheriff took a sample of the mixture we used.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’d like to talk to Sister Clothilde, and then see her garden.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can take you to see the garden, but Sister Clothilde won’t be able to speak to you, even through the grille. She’s taken a vow of silence.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How does she communicate with the rest of the order?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Through a special form of sign language we’ve developed to communicate with each other during times of silence. It’s very limited. But she can listen, and she can write down answers. She’s allowed to do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All right. Show me the herb garden, then we’ll see if we need to trouble Sister Clothilde about the rest.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All right,” she said, and stood up. “But Mr. Brown, the herbs Sister Clothilde grows are quite common and completely harmless.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Accidental poisonings are common in rural areas of New Mexico, Sister. The fact of the matter is that the symptoms you and Sister Bernarda described to me reminded me of another case I worked on when I first became a medical investigator. An elderly Hispanic man died as a result of an overdose of an herbal medicine he took for pain. Which brings me to my next question. Does Sister Clothilde also grow medicinal plants?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A few, yes. I’ve heard of her using chamomile to settle the stomach, and something called alegria, which is said to be good for the heart. The Spanish word means ‘happiness,’ so it worried us at first. We certainly don’t need stimulants. But it’s harmless. There are also herbs to treat high blood pressure and other ailments.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Take me to see the garden, then. Herbal medicine isn’t always as safe as people think. The elderly man I told you about experimented with the anesthetic properties of monkshood and died because that plant also contains highly toxic alkaloids.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let me get Reverend Mother’s permission, then I’ll take you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Leaving the medical investigator in the chapel, Sister Agatha went through the corridors of the monastery quickly, and found Reverend Mother praying in her office before a statue of the Blessed Virgin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sister Agatha remained by the door, hating to interrupt the abbess at prayer but knowing she had no other choice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Praised be Jesus Christ,” Sister Agatha said quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Now and forever,” Reverend Mother answered, and turned around. “Have the police finished what they need to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sister Agatha filled Reverend Mother in quickly, and saw shock and then sorrow in her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You were a reporter, and later a journalism professor, child. You understand investigative methods and thought processes more than any of us. I need you to remain with these people at all times while they’re here at the monastery. And please make sure poor Sister Clothilde isn’t harassed in any way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve told the medical investigator, Mr. Brown, about Sister’s vow of silence. He understands that he can’t speak to her—at least not directly—and has agreed to that. But he insists on examining our garden to make sure the herb tea didn’t contain anything harmful.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then show it to him. He’ll see for himself that we don’t grow anything dangerous here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Right away, Mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Agatha walked back quickly to the chapel. She had to find a way to convince the police that their answers lay outside the monastery. Maybe once the medical investigator saw their small garden, he’d understand how simple their lives were and that whatever had happened to Father Anselm was in no way connected to the monastery or the sisters.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mr. Brown,” Sister Agatha said as she came up to him, “I’m ready to show you the garden. It’s in the back of the building, and though not behind cloister, it is a restricted area. Please keep your voice low so we don’t disturb any of the sisters who might be praying. And should you see one of our sisters, don’t attempt to speak to her without checking with me first. Will you agree to this?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All right. You’ve got yourself a deal.” Brown nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She walked with the man to the back of the monastery, all of which was enclosed behind a high wall. As they reached the garden—a large field sectioned off into rows of corn, tomatoes, squash, carrots, pinto beans, and chile—she spread out her arms. “This is it. Most of what graces our table is grown here, with the exception of staples like flour, salt, sugar, and such. We’re all vegetarians. The herbs are in the last row,” she said, leading him to the north side of the garden.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stepped from row to row, examining the plants and studying the ground between them, then finally reached the row containing the herbs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Most of these plants are gifts that the monastery has received from our neighbors in the community.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He spoke aloud as he identified chamomile, mint, sage, rosemary, and various other common culinary herbs. He also snipped off samples of the medicinal plants Sister Agatha pointed out as ones used to treat high blood pressure, fevers, colds, and other common problems. After searching the entire area carefully, he stood up straight and shook his head. “There’s nothing out of the ordinary here. Heck, I couldn’t even find a weed,” he said with amazement. “Is this the only place where you grow herbs?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This is it. The only other plants we cultivate and grow here are roses. Everything else, including the trees, is part of the desert landscaping and requires no tending.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She escorted him around the grounds so he could see for himself. “Nothing in our gardens is capable of injuring anyone—unless you count the rose thorns,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I admire your loyalty to the monastery, Sister Agatha,” he said as they reached the chapel.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His words surprised her. This wasn’t a matter of being loyal. It was common sense. To think that any of the sisters pledged to a religious life could intentionally harm another living being was completely crazy. They even freely shared the fruits of their labor with the cottontail rabbits who, from time to time, ravaged the vegetables they grew.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As they stood on the front steps of the chapel, she watched the deputies loading the boxes of evidence into their vehicles.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s time for me to get going, too,” Brown said, then shook hands with her. “With luck, none of us will have to come back.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“God doesn’t depend on luck, He gives us prayer and faith instead.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He smiled, then with a wave, walked away from her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t count on this being the end of it,” Tom said as he approached, apparently having overheard at least the end of their conversation. “I’ve heard about Sister Clothilde’s vow of silence, but if the investigation continues, it may be necessary for her to speak to us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Communicate, maybe—speak, no.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Whatever. This isn’t over. Mark my words.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Have you learned something new, Sheriff?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Only the names of the people from the community who were here at Mass. Sister Bernarda gave me a list. I’ll have to track them down now. But, you know, I’ve got a gut feeling that this one was an inside job.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re wrong.” She gave him a long, thoughtful look. “You don’t sense any of it, do you? The peace that’s here, the quiet purpose—everything that defines this place and makes it special.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He met her gaze and shrugged. “All I see is women living together behind walls. It’s no more or less a prison than the one near Los Lunas or Santa Fe.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’re here in this monastery so we can work for the world. Through our prayers, we make a difference. But like doctors who have to keep a professional distance from their patients, we can do our job better by remaining separate.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, I wouldn’t count on staying too ‘separate.’ If I don’t get the answers I need, I’ll have to come back. And, if that happens, I won’t cut you or the monastery any slack. I’ll do whatever it takes to find out what happened to Father Anselm, including getting the paperwork I need to enter your cloister. And if you get in my way, I’ll throw the book at you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She smiled. “For the record, my book’s a lot heavier than yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As Sheriff Green strode off without another word, she understood that a warning had been given. Sorrow and apprehension weighed down her spirit as she turned around and walked back inside.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f94ecfb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429909587_ch02.vue
// module id = 81
// module chunks = 0